import useFetchPublisherAggregateRevenue from "api/AdminReports/useFetchPublisherAggregateRevenue";
import RevenueReportPanel, { useRevenuePeriod } from "components/CurrencyRevenueReport/RevenueReportPanel";

export default function PublisherRevenueReport({ userId }) {
    const { period, setPeriod, query } = useRevenuePeriod();
    const result = useFetchPublisherAggregateRevenue(query, userId);
    return <RevenueReportPanel compact publisher {...{ result, period, setPeriod }} />;
}
